export const COUNTRY_CODES = [
  { code: '+1', label: 'US/CA' },
  { code: '+91', label: 'IN' },
];